import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import HDrawer from '../../common/HDrawer';
import Session from '../components/Session';
import CalendarSummaryDrawerSummaryHeader from './CalendarSummaryDrawerSummaryHeader';
import SessionNotes from '../components/SessionNotes';
import CalendarSummaryFeed from './CalendarSummaryFeed';

import * as CalendarState from '../../../state/reducer/calendar/calendar';
import CONF from '../../../api/config';

import Console from '../../../lib/debug';

class CalendarSummaryDrawer extends Component {
    cancelDrawer() {
        CalendarState.toggleBasicDrawer(true);
    }

    getAvatarUrl() {
        const { athleteId, team } = this.props.infoTree;

        if (athleteId) {
            return `${CONF.API}/avatars/user/${athleteId}`;
        }

        return team.logo;
    }

    render() {
        Console.render('CalendarSummaryDrawer');
        const { feedData, open, infoTree, loggedInUser } = this.props;

        let sessionSummary = null;
        let session = null;
        let sessionTitle = null;
        let sessionDate = null;
        let overriddenSessionDate = null;

        if (feedData && feedData.session && open) {
            session = feedData.session;
            sessionTitle = session.title;

            sessionDate = session.date_rescheduled
                ? moment(session.date_rescheduled).format('MMMM Do, YYYY')
                : moment(session.date).format('MMMM Do, YYYY');

            overriddenSessionDate = session.date_rescheduled
                ? moment(session.date).format('MMMM Do, YYYY')
                : null;

            if (overriddenSessionDate === sessionDate) {
                overriddenSessionDate = null;
            }

            sessionSummary = (
                <div className="calendar-summary-drawer-session">
                    <Session
                        session={session}
                        isPubEnabled={false}
                        publishDate={0}
                        isPreview={false}
                        fromDrawer={true}
                    />
                </div>
            );
        }

        return (
            <HDrawer
                open={open || false}
                onClose={this.cancelDrawer}
                title={infoTree.team.title}
                hasFeedInput={true}
                subTitle={sessionTitle}
                overriddenCaption={overriddenSessionDate}
                caption={sessionDate}
                iconUrl={this.getAvatarUrl()}
            >
                <CalendarSummaryDrawerSummaryHeader session={session} />
                <SessionNotes session={session} />
                <CalendarSummaryFeed
                    feedData={feedData}
                    loggedInUser={loggedInUser}
                />
                {sessionSummary}
            </HDrawer>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        feedData: state.feed.feedData,
        infoTree: state.calendar.infoTree,
        loggedInUser: state.app.loggedInUser,
        open: state.calendar.uiTree.drawerOpen
    };
};

CalendarSummaryDrawer = connect(mapStateToProps)(CalendarSummaryDrawer);

export default CalendarSummaryDrawer;



// WEBPACK FOOTER //
// ./src/view/calendar/calendar-summary-drawer/CalendarSummaryDrawer.jsx